export default __webpack_public_path__ + "images/5338e39e749ad5cb37403921f251bfaa.svg";